module.exports = __webpack_public_path__ + "static/media/icon-videoupload.2ff52f08.svg";